import { createContext } from 'react';
import { MainOfferStore } from '@gp/offer';

const defaultValue: MainOfferStore = new MainOfferStore();
export const OfferStoreContext = createContext<MainOfferStore>(defaultValue);